/**
 * Register limit checkers for core features (users, etc.)
 * 
 * This is called automatically by apps to register limits for features
 * that are managed in the core features package.
 */

import { registerLimitChecker, registerLimitInfoGetter } from './limitRegistry';
import { useUsersStore } from '../users/usersStore';

/**
 * Initialize core feature limit checkers
 * Call this once during app initialization
 */
export function registerCoreLimits(): void {
  // Users
  registerLimitChecker('users', () => 
    useUsersStore.getState().hasReachedLimit()
  );
  registerLimitInfoGetter('users', () => 
    useUsersStore.getState().getUserLimit()
  );
}
